var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78138 20C4.62685 20 4.47578 19.9542 4.34728 19.8684C4.21877 19.7825 4.11862 19.6605 4.05948 19.5177C4.00033 19.375 3.98486 19.2179 4.01502 19.0663C4.04518 18.9147 4.11961 18.7755 4.22889 18.6663L18.6662 4.22885C18.8127 4.08232 19.0114 4 19.2187 4C19.4259 4 19.6246 4.08232 19.7711 4.22885C19.9177 4.37538 20 4.57412 20 4.78135C20 4.98857 19.9177 5.18731 19.7711 5.33384L5.33388 19.7713C5.26139 19.8439 5.17526 19.9015 5.08045 19.9407C4.98564 19.98 4.884 20.0001 4.78138 20Z",
    fill: "#304059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2186 20C19.116 20.0001 19.0144 19.98 18.9195 19.9407C18.8247 19.9015 18.7386 19.8439 18.6661 19.7713L4.22885 5.33384C4.08232 5.18731 4 4.98857 4 4.78135C4 4.57412 4.08232 4.37538 4.22885 4.22885C4.37538 4.08232 4.57412 4 4.78134 4C4.98857 4 5.1873 4.08232 5.33383 4.22885L19.7711 18.6663C19.8804 18.7755 19.9548 18.9147 19.985 19.0663C20.0151 19.2179 19.9997 19.375 19.9405 19.5177C19.8814 19.6605 19.7812 19.7825 19.6527 19.8684C19.5242 19.9542 19.3732 20 19.2186 20Z",
    fill: "#304059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCross);
export default __webpack_public_path__ + "static/media/blue-cross.0fbe09dc7510d6545e0815a39e998125.svg";
export { ForwardRef as ReactComponent };